module.exports = __webpack_public_path__ + "static/media/octorion-intro.390d1d96.svg";